import axios from "axios";
import { apiConstants } from "../constants";

export default axios.create({
  baseURL: apiConstants.API_URL,
  responseType: "json"
});
